import React, { useState, useRef } from 'react'
import styles from './Phase3.module.css'
import IconVolume from '../../../../../assets/icons/IconVolume'
import IconSwitch from '../../../../../assets/icons/IconSwitch'
import Image from '../../components/Image/Image'
import {
    getSoundDownloadUrl,
} from '../../components/Sound/Sound'
import { shuffledArray } from '../../../../../util/util'


const Phase3 = ({
    words,
    onNextPhase,
    onProgress,
}) => {

    const mediaPlayer = useRef(new Audio());
    const shuffledWords = useRef(shuffledArray(words.filter((word) => word.gender !== 'Neutral')));

    const [currIndex, setCurrIndex] = useState(0);

    const [wordMode, setWordMode] = useState(0);
    const [switchTransition, setSwitchTransition] = useState(false)

    const [transition, setTransition] = useState(false)
    const [bad, setBad] = useState(null)
    const [good, setGood] = useState(null)
    const [fadeOut, setFadeOut] = useState(false)


    const handleSwitch = () => {

        setSwitchTransition(true)
        setTimeout(() => {
            setSwitchTransition(0)
            if (wordMode === 1) setWordMode(0)
            else setWordMode(1)
        }, 500);
    }

    const playSound = () => {
        getSoundDownloadUrl(shuffledWords.current[currIndex].sound_path)
            .then((url) => {
                mediaPlayer.current.pause();
                mediaPlayer.current.src = url
                mediaPlayer.current.play()
            })

    }

    const handleGenderClick = (gender) => {
        setTransition(true)
        if (gender === shuffledWords.current[currIndex].gender) {
            setGood(gender)
            onProgress(currIndex + 1)
            setTimeout(() => {
                setFadeOut(true)
            }, 500);
    
            setTimeout(() => {
                setFadeOut(false)
                setTransition(false)
                setGood(null)
                setWordMode(0)
                if (currIndex + 1 >= shuffledWords.current.length) {
                    onNextPhase()
                }
                else {
                    setCurrIndex(prevIndex => prevIndex + 1)
                }

                
            }, 1000);
        }
        else {
            setBad(gender)
            setTimeout(() => {
                setBad(null)
                setTransition(false)
            }, 500);
        }

        
    }

    return (
        <div className={styles.container}>
            <div
                onClick={transition || switchTransition || wordMode ? null : () => playSound()}
                className={styles.wordContainer}
                style={{ opacity: switchTransition || fadeOut ? 0 : 1 }}>
                {wordMode ?
                    <>
                        <Image imagePath={shuffledWords.current[currIndex].img_path} size={200} />
                        <p className={styles.wordTitleEnglish}>{shuffledWords.current[currIndex].eng}</p>
                    </> :
                    <>
                        <IconVolume size={24} className={styles.volumeIcon} />
                        <p className={styles.wordTitle}>{shuffledWords.current[currIndex].vow}</p></>}

            </div>
            <IconSwitch
                onClick={transition ? null : () => handleSwitch()}
                size={32}
                className={styles.switchButton} />
            <div className={styles.buttonsContainer}>
                <p
                    onClick={transition ? null : () => handleGenderClick('Male')}
                    className={styles.genderButton}
                    style={{
                        backgroundColor: good === 'Male' ? '#26C281' : bad === 'Male' ? '#FF6464' : 'white',
                        color: good === 'Male' || bad === 'Male' ? 'white' : 'black'
                    }}>Male</p>
                <p
                    onClick={transition ? null :() => handleGenderClick('Female')}
                    className={styles.genderButton}
                    style={{
                        backgroundColor: good === 'Female' ? '#26C281' : bad === 'Female' ? '#FF6464' : 'white',
                        color: good === 'Female' || bad === 'Female' ? 'white' : 'black'
                    }}>Female</p>
                <p
                    onClick={transition ? null : () => handleGenderClick('Both')}
                    className={styles.genderButton}
                    style={{
                        backgroundColor: good === 'Both' ? '#26C281' : bad === 'Both' ? '#FF6464' : 'white',
                        color: good === 'Both' || bad === 'Both' ? 'white' : 'black'
                    }}>Both</p>
            </div>
        </div>
    )
}

export default Phase3
